import { Box, Select, styled } from '@mui/material';
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro';

export const FlexEnd = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'flex-end',
}));

export const FlexSpaceBetween = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
}));

export const InlineFlex = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'inline-flex',
  gap: theme.spacing(1),
}));

export const SkinnySelect = styled(Select)(() => ({
  minWidth: '200px',
  '& > div': {
    paddingBottom: '10px',
    paddingTop: '11px',
  },
}));

export const SpreadsheetyDataGrid = styled(DataGrid)(({ theme }) => ({
  '& [data-field="__check__"]': {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    borderRight: `1px solid ${theme.palette.borders.light}`,
  },
  '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
    display: 'none',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-columnSeparator--resizable': {
    color: 'rgba(0,0,0,0.25)',
    display: 'flex',
    '&:hover': {
      color: 'rgba(0,0,0,0.25)',
    },
  },
})) as typeof DataGrid;
